<template>
  <div class="d-flex flex-column pt-10">
    <v-form @submit.prevent="submit" class="d-flex flex-column pa-12">
        <p>Έχετε κάποιο απο τα ακόλουθα συμπτώματα;</p>
        <v-checkbox class="pa-0 ma-0" label="Βήχας" v-model="questionnaire.cough"></v-checkbox>
        <v-checkbox class="pa-0 ma-0" label="Δύσπνοια/δυσκολία στην αναπνοή" v-model="questionnaire.breathlessness"></v-checkbox>

        <p>Έχετε τουλάχιστον δύο απο τα ακόλουθα συμπτώματα;</p>
        <v-checkbox class="pa-0 ma-0" label="Πυρετός" v-model="questionnaire.fever"></v-checkbox>
        <v-checkbox class="pa-0 ma-0" label="Κρυάδες" v-model="questionnaire.colds"></v-checkbox>
        <v-checkbox class="pa-0 ma-0" label="Ρίγη" v-model="questionnaire.shiver"></v-checkbox>
        <v-checkbox class="pa-0 ma-0" label="Μυικό πόνο" v-model="questionnaire.muscularPain"></v-checkbox>
        <v-checkbox class="pa-0 ma-0" label="Πονοκέφαλο" v-model="questionnaire.headache"></v-checkbox>
        <v-checkbox class="pa-0 ma-0" label="Ξηρό λαιμό" v-model="questionnaire.soreThroat"></v-checkbox>
        <v-checkbox class="pa-0 ma-0" label="Απώλεια γεύσης ή όσφρησης" v-model="questionnaire.noTaste"></v-checkbox>
        <v-divider></v-divider>
        <v-checkbox label="Διαμένη σε περιοχή που έχει μπει σε καραντίνα" v-model="questionnaire.liveInQuarantinedPlace"></v-checkbox>
<v-divider></v-divider>
        <v-checkbox label="Έχει διαγνωστεί συγκενής μου θετικός τις τελευταίες 21 ημέρες" v-model="questionnaire.familyHasCovid"></v-checkbox>
        <v-divider></v-divider>
        <v-checkbox label="Τις τελευταίες 21 ημέρες έχω έρθει σε επαφή με άτομο που έχει διαγνωστεί με COVID-19" v-model="questionnaire.lastTwentyOneDays"></v-checkbox>
        <v-divider></v-divider>
        <v-checkbox label="Έχετε νοσηλευτεί για COVID-19" v-model="questionnaire.goneHospital"></v-checkbox>
        <v-divider></v-divider>
        <v-checkbox label="Έχετε κάποια ασθένεια απο τις ακόλουθες: Άσθμα, Χρόνια πνευμονοπάθεια, Διαβήτη, Καρδιακά νοσήματα, Χρόνια νεφροπάθεια, υψηλό βάρος, ανοσοκαταστολή, ασθένεια του ήπατος" v-model="questionnaire.diseases"></v-checkbox>

        <v-btn type="submit" tile depressed class="buttonText mt-10" width="180" color="primary">Υποβολή</v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  data(){
    return{
      questionnaire: {
        cough: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.cough,
        breathlessness: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.breathlessness,
        fever: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.fever,
        colds: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.colds,
        shiver: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.shiver,
        muscularPain: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.muscularPain,
        headache: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.headache,
        soreThroat: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.soreThroat,
        noTaste: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.noTaste,
        liveInQuarantinedPlace: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.liveInQuarantinedPlace,
        familyHasCovid: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.familyHasCovid,
        lastTwentyOneDays: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.lastTwentyOneDays,
        goneHospital: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.goneHospital,
        diseases: this.$store.state.frontDesk.newTouristTest?.formJsonText?.questionnaire?.diseases
      }
    }
  },

  methods: {
    submit(){
      const credentials = {
        questionnaire: this.questionnaire
      }

      this.$store.dispatch('newTouristTestSecond', credentials)
    }
  }
}
</script>